import { apiClient } from './client'

export type ReviewMode = 'CLASSIC' | 'REVERSE' | 'FILL_BLANK' | 'MULTIPLE_CHOICE'

export interface ReviewOption {
  id: string
  text: string
}

export interface ReviewCard {
  id: string
  wordId: string
  word: string
  translation: string
  phonetic?: string
  audioUrl?: string
  partOfSpeech?: string
  cefrLevel?: string
  examples: string[]
  mode: ReviewMode
  questionText: string
  answerText: string
  options?: ReviewOption[]
  senseGloss?: string
  knownTranslations?: string[]
  /** WORD, PHRASE / PHRASAL_VERB / IDIOM, or GRAMMAR (Episode) */
  unitType?: string
}

export interface SubmitReviewRequest {
  userWordId?: string
  userPhraseId?: string
  /** C3 — Understanding Snapshot (grammar) */
  episodeId?: string
  wordId?: string
  rating: 0 | 1 | 2 | 3
  answerTimeMs: number
  sessionId: string
}

export interface ReviewResult {
  wordId: string
  newStatus: string
  nextReviewAt: string
  newInterval: number
  newEaseFactor: number
}

export interface CompleteSessionRequest {
  sessionId: string
  cardsReviewed: number
  correctCount: number
  durationMs: number
}

export interface SessionSummary {
  cardsReviewed: number
  accuracy: number
  studyTimeMin: number
  streakUpdated: boolean
  currentStreak: number
  growthHighlight?: string | null
}

export const reviewApi = {
  getDueCards: (limit = 20, mode: ReviewMode = 'CLASSIC', userWordIds?: string[]) =>
    apiClient.get<ReviewCard[]>('/review/due', {
      params: {
        limit,
        mode,
        ...(userWordIds?.length ? { userWordIds } : {}),
      },
    }).then((r) => r.data),

  submitReview: (req: SubmitReviewRequest) =>
    apiClient.post<ReviewResult>('/review/submit', req).then((r) => r.data),

  completeSession: (req: CompleteSessionRequest) =>
    apiClient.post<SessionSummary>('/review/session/complete', req).then((r) => r.data),
}
